export default __webpack_public_path__ + "static/media/portex-logo-filled.6a8919c5.png";